import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/api/v1`
  : '/api/v1';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { 'x-auth-token': token } : {};
};

const userApi = {
  /**
   * Get all internal staff users (excludes property owners)
   * Used for task assignment dropdowns
   * @returns {Promise} Response with users array
   */
  getStaffUsers: async () => {
    const response = await axios.get(`${API_URL}/users`, {
      headers: getAuthHeader(),
      params: {
        role: 'admin,ops,ops-manager,maintenance,maintenance-supervisor,service',
        // Don't filter by status - include both active and invited users
        limit: 100
      }
    });

    // Filter out suspended/archived users on client side
    const users = response.data.users || [];
    const activeUsers = users.filter(u =>
      u.status === 'active' || u.status === 'invited'
    );

    return { ...response.data, users: activeUsers };
  },

  /**
   * Get all property owner accounts (for admin/ops account switcher)
   * @returns {Promise} Response with accounts array
   */
  getAccounts: async () => {
    const response = await axios.get(`${API_URL}/users`, {
      headers: getAuthHeader(),
      params: {
        role: 'turnKeyOwner', // Get all owner types
        // Include both active and pending owners (pending may have properties assigned)
        limit: 1000, // High limit for account switcher
        includePropertyCount: true // Include property counts for user management
      }
    });

    return response.data;
  }
};

export default userApi;
